import type { IConnectorStatus } from '@/types/connector'

export const CONNECTORS_LIST = {
  TITLE: 'Connectors',
  SEARCH_PLACEHOLDER: 'Search connectors by name...',
  NO_RESULTS: 'No connectors found matching your search.',
  LOADING: 'Loading connectors...',
  LAST_SYNC: 'Last sync:',
  NEVER_SYNCED: 'Never synced',
  SYNCED_JUST_NOW: 'Synced just now',
  SYNCED_HOURS_AGO: (hours: number) => `Synced ${hours}h ago`,
  SYNCED_DAYS_AGO: (days: number) => `Synced ${days}d ago`,
  CONNECT: 'Connect',
  MANAGE: 'Manage',
  COMING_SOON: 'Coming Soon',
  STATUS: {
    completed: 'Completed',
    notStarted: 'Not connected',
    error: 'Error',
  } satisfies Record<NonNullable<IConnectorStatus>, string>,
  POPUP_CONNECT_ERROR: 'Error trying to connect to Oauth provider',
}

export const CONNECTION_SUCCESS = {
  TITLE: 'Connection successful',
  SUBTITLE: 'OAuth configuration completed',
  MESSAGE: 'Close this window to complete the setup process.',
  BUTTON: 'Close',
}

export const CONNECTION_FAILED = {
  TITLE: 'Connection failed',
  SUBTITLE: 'OAuth configuration could not be completed',
  MESSAGE: 'Close this window to try again or contact support.',
  BUTTON: 'Close',
}
